// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__cN_x4","flex":"page_flex__Bs_Nb","block":"page_block__V0C9S","textRed":"page_textRed__06eNM","copyright":"page_copyright__5opHQ"};